import Tooltip from './component';
import withTooltip from './hoc';

export {
  Tooltip,
  withTooltip,
}



// WEBPACK FOOTER //
// ./src/Tooltip/index.js


// WEBPACK FOOTER //
// webpack:///src/Tooltip/index.js